export default [
  {
    name: 'Acl Entities',
    path: '/acl/entities',
    component: () => import('@/modules/acl/aclEntities/pages/AclEntities'),
    meta: {
      ability: [
        {
          resource: 'acl_entities',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add Acl Entity',
    path: '/acl/entities/add',
    component: () => import('@/modules/acl/aclEntities/pages/AclEntityDetails'),
    meta: {
      ability: [
        {
          resource: 'acl_entities',
          actions: ['create'],
        },
        {
          resource: 'domains',
          actions: ['read'],
        },
        {
          resource: 'permissions',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Edit Acl Entity',
    path: '/acl/entities/edit/:id',
    component: () => import('@/modules/acl/aclEntities/pages/AclEntityDetails'),
    meta: {
      ability: [
        {
          resource: 'acl_entities/:id',
          actions: ['update'],
        },
        {
          resource: 'domains',
          actions: ['read'],
        },
        {
          resource: 'permissions',
          actions: ['read'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
